module.exports = __webpack_public_path__ + "img/ruffle_lenght.824e1cf6.png";